var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#D63D45;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.3,2.3C3.9,0.8,5.8,0,8,0s4.1,0.8,5.7,2.3C15.2,3.9,16,5.8,16,8c0,2.2-0.8,4.1-2.3,5.7 C12.1,15.2,10.2,16,8,16s-4.1-0.8-5.7-2.3C0.8,12.1,0,10.2,0,8C0,5.8,0.8,3.9,2.3,2.3z M8.8,8.8V4H7.2v4.8H8.8z M8.8,12v-1.6H7.2 V12H8.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorRed);
export default __webpack_public_path__ + "static/media/error_red.c573428818dcde7abc5e52357cb63cd4.svg";
export { ForwardRef as ReactComponent };